module.exports = __webpack_public_path__ + "img/close_x.e1a98685.svg";